import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { listGradientBG } from "../constants/value";
import logoSIASN from "../assets/logo-siasn.png";
import logoBKN from "../assets/logo-bkn-new.png";

export default function Layout({ children }) {
  const [gradientBG, setGradientBG] = useState(listGradientBG[0]);
  useEffect(() => {
    const randomNumber = Math.floor(Math.random() * (9 - 0) + 0);
    setGradientBG(listGradientBG[randomNumber]);
  }, []);

  return (
    <div
      style={{
        backgroundImage: gradientBG,
      }}
    >
      <div
        style={{
          width: "100%",
          padding: "12px 24px",
          borderRadius: "0",
          // background: "rgba(255, 255, 255, 0.85",
          justifyContent: "space-between",
          display: "flex",
          placeItems: "center",
        }}
        // className="glass-effect"
      >
        <a href="https://siasn.bkn.go.id/">
          <img alt="logo-siasn" src={logoSIASN} height="36px" />
        </a>
        <a href="https://bkn.go.id/">
          <img alt="logo-siasn" src={logoBKN} height="42px" />
        </a>
      </div>
      <div
        style={{
          minHeight: "calc(100vH - 66px - 68px)",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>{children}</Container>
      </div>
      <div
        style={{
          width: "100%",
          padding: "24px 24px",
          borderRadius: "0",
          // background: "rgba(255, 255, 255, 0.85)",
          textAlign: "center",
          fontSize: "13px",
          opacity: "0.85",
        }}
        // className="glass-effect"
      >
        <b>© 2020-{new Date().getFullYear()} Badan Kepegawaian Negara</b>
      </div>
    </div>
  );
}
